import React from 'react'
import IMG from "./HTML.png"
function LogoHtml() {
  return (
    <img src={IMG} style={{width:"200px",height:"150px" }} alt='html' />
  )
}

export default LogoHtml